var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18H29V0H0V18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17.9675H29V15.3779H0V17.9675Z",
    fill: "#F7B600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.58955H29V0H0V2.58955ZM14.2117 5.44091L12.6705 12.5476H10.8046L12.3474 5.44009H14.2117V5.44091ZM22.0582 10.0293L23.0401 7.36036L23.6052 10.0293H22.0582ZM24.1404 12.5476H25.8647L24.3583 5.44009H22.7675C22.4087 5.44009 22.1063 5.64464 21.9721 5.96127L19.174 12.5476H21.1327L21.5221 11.4856H23.9142L24.1404 12.5476ZM19.2717 10.2273C19.28 8.35118 16.6419 8.24727 16.6584 7.40864C16.6651 7.155 16.9111 6.88336 17.4497 6.81382C17.7173 6.78027 18.4531 6.75245 19.2891 7.13209L19.6156 5.62418C19.0577 5.41825 18.4671 5.31186 17.8715 5.31C16.0279 5.31 14.7312 6.27545 14.7204 7.659C14.7088 8.68255 15.6467 9.25282 16.3527 9.594C17.0793 9.94254 17.3238 10.1659 17.3196 10.4768C17.3147 10.9538 16.7396 11.1649 16.2044 11.1723C15.2656 11.187 14.7229 10.9227 14.2887 10.7239L13.9507 12.2817C14.3873 12.4781 15.191 12.6499 16.0237 12.6589C17.9841 12.6589 19.2659 11.7041 19.2717 10.2273ZM11.547 5.44091L8.52517 12.5476H6.55317L5.06754 6.87518C4.97723 6.52664 4.89934 6.39818 4.62509 6.25091C4.176 6.01118 3.43609 5.78618 2.78483 5.64545L2.82874 5.44091H6.00217C6.40651 5.44091 6.77026 5.70518 6.86306 6.16418L7.64854 10.2772L9.58823 5.44009H11.5478L11.547 5.44091Z",
    fill: "#1A1F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.f466e899c4ca316df02a582df371a000.svg";
export { ForwardRef as ReactComponent };